export default {"src":"/_next/static/media/industrial-icon.cd3162da.svg","height":92,"width":129,"blurWidth":0,"blurHeight":0};